// extracted by mini-css-extract-plugin
export default {"shadowed":"BaseLayout_shadowed__sNaX8","dark":"BaseLayout_dark__km+Xv","home":"BaseLayout_home__ciurZ","button":"BaseLayout_button__o6jkn","light":"BaseLayout_light__ldtJE"};